const PHRASES = ["Navegue pelo extraordinário", "SG Turismos", "Experiências únicas no mar"];

const Sequence = () => (
  <>
    {PHRASES.map((text, i) => (
      <span key={i} className="mx-6 inline-flex items-baseline gap-6 md:mx-10">
        <span
          className={`whitespace-nowrap text-2xl md:text-4xl ${
            i % 2 === 1 ? "font-light italic text-air" : "font-light text-paper"
          }`}
        >
          {text}
        </span>
        <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0 self-center text-sea" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
          <path d="M2 12c2.5-2 5-2 7.5 0s5 2 7.5 0 3.5-1.6 5-1" strokeLinecap="round" />
          <path d="M2 17c2.5-2 5-2 7.5 0s5 2 7.5 0" strokeLinecap="round" opacity="0.5" />
        </svg>
      </span>
    ))}
  </>
);

export default function Marquee() {
  return (
    <section
      data-testid="marquee-band"
      className="marquee-band overflow-hidden border-y border-navy bg-navy py-8 md:py-10"
      aria-label="Navegue pelo extraordinário — SG Turismos"
    >
      <div className="marquee-track flex w-max">
        <Sequence />
        <Sequence />
      </div>
    </section>
  );
}
